import * as types from '../mutation-types'
import vueCookie from 'vue-cookie'

// initial state
const state = {
    cookieLeague    : (localStorage.getItem(window.compcode + '_league') != 'undefined') ? JSON.parse(localStorage.getItem(window.compcode + '_league')) : null,
    selectAllLeague : (localStorage.getItem(window.compcode + '_league') != 'undefined') ? false : true,
    cookieHistory   : (localStorage.getItem(window.compcode + '_his') != 'undefined') ? JSON.parse(localStorage.getItem(window.compcode + '_his')) : null,
    searchHistory   : [],
    searchLoading   : false,
    historyList     : [],
}

// getters
const getters = {
  cookieLeague    : state => state.cookieLeague,    
  selectAllLeague : state => state.selectAllLeague,
  cookieHistory   : state => state.cookieHistory,
  searchHistory   : state => state.searchHistory,
  searchLoading   : state => state.searchLoading,
  historyList     : state => state.historyList,
}

// actions
const actions = {
    
}

// mutations
const mutations = {
    [types.SELECT_ALL_LEAGUE] (state,payload) {
        state.selectAllLeague = payload
    },
    [types.COOKIE_LEAGUE] (state, payload ) {
        var selectedMarket = this.getters.selectedMarket
        var selectedSport = this.getters.selectedSport
        // if(this.getters.isGameBannerSelected) {
        //     selectedBettype += 'gmBanner'
        // }
        
        if(payload.remove){
            if(this.getters.cookieLeague){
                if(this.getters.cookieLeague[selectedMarket]){
                    if(this.getters.cookieLeague[selectedMarket][selectedSport]){
                        state.cookieLeague[selectedMarket][selectedSport] = []
                        // vueCookie.set(window.compcode + '_league', JSON.stringify(state.cookieLeague))
                        localStorage.setItem(window.compcode + '_league', JSON.stringify(state.cookieLeague))
                    }
                }
            }
            // vueCookie.delete(window.compcode + '_league')
            return
        }
        
        let VUE = this
        function recursiveMethod(value, type, league){
            var selectedMarket = VUE.getters.selectedMarket
            var selectedSport = VUE.getters.selectedSport
            // if(VUE.getters.isGameBannerSelected) {
            //     selectedBettype += 'gmBanner'
            // }
            if(value == null && type =='market') {
                value[selectedMarket] = {}
                return recursiveMethod(value[selectedMarket], 'sport', league)
            }

            if(value == null && type =='sport') {
                value[selectedMarket][selectedSport] = []
                value[selectedMarket][selectedSport] = league
                return value
            }else {
                if(value == null){
                    return recursiveMethod(value, 'market', league)
                }
                if(value[selectedMarket] == null){
                    value[selectedMarket] = {}
                    return recursiveMethod(value, 'sport', league)
                }
                if(value[selectedMarket][selectedSport] == null){
                    value[selectedMarket][selectedSport] = league
                    return value;
                }
                value[selectedMarket][selectedSport] = league
                return value;
            }
        }
        if(this.getters.cookieLeague){
            //if cookie is set already            
            var cookie = ''
            cookie = recursiveMethod(this.getters.cookieLeague, 'market', payload.selectedLeague)
            state.cookieLeague = cookie
            // vueCookie.set(window.compcode + '_league', JSON.stringify(cookie))
            localStorage.setItem(window.compcode + '_league', JSON.stringify(cookie))
        }else{
            //league cookie initiation
            //if cookie is not set
            var selectedCookieLeague = {};
            selectedCookieLeague[selectedMarket] = {}
            selectedCookieLeague[selectedMarket][selectedSport] = payload.selectedLeague
            state.cookieLeague = selectedCookieLeague
            // vueCookie.set(window.compcode + '_league', JSON.stringify(selectedCookieLeague))
            localStorage.setItem(window.compcode + '_league', JSON.stringify(selectedCookieLeague))
            return
        }
        //vueCookie.set(window.compcode + '_league', JSON.stringify(payload.selectedLeague))
    },    
    [types.COOKIE_HISTORY] (state, payload){
        //search history cookies
        let currentAcc = this.getters.account.acccode

        if(payload.remove){
            if(this.getters.cookieHistory){
                state.cookieHistory = []
                // vueCookie.set(window.compcode + '_his', JSON.stringify(state.cookieHistory))
                localStorage.setItem(window.compcode + '_his', JSON.stringify(state.cookieHistory))
            }
            return
        }

        if(payload.removeSelected){
            if(this.getters.cookieHistory){
                state.cookieHistory = _.pull(this.getters.cookieHistory, payload.searchVal)
                // vueCookie.set(window.compcode + '_his', JSON.stringify(state.cookieHistory))
                localStorage.setItem(window.compcode + '_his', JSON.stringify(state.cookieHistory))
            }
            return
        }

        if(_.includes(state.cookieHistory, payload.searchVal)){
            return
        }

        let VUE = this
        if(state.cookieHistory && state.cookieHistory && state.cookieHistory.length>0){
            state.searchHistory = _.reverse(state.cookieHistory)
        }
        if(state.searchHistory.length==0 || state.searchHistory.length <3){
            if(payload.searchVal!=''){
                state.searchHistory.push(payload.searchVal)
            }
        }else{
            if(payload.searchVal!=''){
                // state.searchHistory = _.reverse(state.searchHistory)
                state.searchHistory.shift()
                state.searchHistory.push(payload.searchVal)
            }
        }
        var selectedCookieLeague = {};
        selectedCookieLeague = _.reverse(state.searchHistory)
        state.cookieHistory = selectedCookieLeague
        // vueCookie.set(window.compcode + '_his', JSON.stringify(selectedCookieLeague))
        localStorage.setItem(window.compcode + '_his', JSON.stringify(selectedCookieLeague))

        return
    },
    [types.SEARCH_LOADING] (state, payload){
        state.searchLoading = payload
    },
    [types.HIST_LIST] (state, payload) {
        state.historyList = payload
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/sport-league.js